import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import ru from './locales/ru.json';
import kz from './locales/kz.json';
import bg from './locales/bg.json';
import fr from './locales/fr.json';

/**
 * Русские формы множественного числа для сообщений из 4 вариантов
 * «ноль | один | несколько | много»: «1 датчик», «2 датчика», «5 датчиков».
 * Для остальных сообщений — правило vue-i18n по умолчанию.
 */
const ruPluralRule = (choice, choicesLength) => {
  const n = Math.abs(choice);
  if (choicesLength === 2) return n ? (n > 1 ? 1 : 0) : 1;
  if (choicesLength !== 4) return n ? Math.min(n, 2) : 0;
  if (n === 0) return 0;
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return 1;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 2;
  return 3;
};

export const i18n = createI18n({
  legacy: false,
  locale: 'ru',
  fallbackLocale: 'ru',
  messages: { en, ru, kz, bg, fr },
  pluralRules: { ru: ruPluralRule }
});

const install = (app) => {
  app.use(i18n);
};

export default install;
